import { combineReducers } from 'redux';
import { get, has } from 'lodash';

import { getMedia, removeHostname } from '../../utils/ASVPUtils';
import { RECEIVE_MEDIA_SOURCE, RECEIVE_CDN_TOKEN_SOURCE, RECEIVE_ACCESS_TOKEN } from '../../actions/ActionTypes';


const tokenReducer = (state = '', action) => {
    switch (action.type) {
        case RECEIVE_CDN_TOKEN_SOURCE:
            return get(action.payload, 'auth.token', '');
        default:
            return state;
    }
};


const accessTokenReducer = (state = '', action) => {
    switch (action.type) {
        case RECEIVE_ACCESS_TOKEN:
            return get(action, 'payload.accessToken', '');
        default:
            return state;
    }
};



const accessTokenTypeReducer = (state = '', action) => {
    switch (action.type) {
        case RECEIVE_ACCESS_TOKEN:
            return get(action, 'payload.accessTokenType', '');
        default:
            return state;
    }
};



const mvpdReducer = (state = '', action) => {
    switch (action.type) {
        case RECEIVE_ACCESS_TOKEN:
            return get(action, 'payload.mvpd', '');
        default:
            return state;
    }
};


const cdnTokenContentPathReducer = (state = '', action) => {
    switch (action.type) {
        case RECEIVE_MEDIA_SOURCE:
            const media = getMedia(action.payload);
            return removeHostname(media.secureUrl);
        default:
            return state;
    }
};


const requiresCDNTokenReducer = (state = false, action) => {
    switch (action.type) {
        case RECEIVE_MEDIA_SOURCE:
            const bulkaesAsset = has(action.payload, 'media.desktop.bulkaes');
            const unprotectedAsset = has(action.payload, 'media.desktop.unprotected');
            return (bulkaesAsset && !unprotectedAsset);
        default:
            return state;
    }
};


export default combineReducers({
    token: tokenReducer,
    accessToken: accessTokenReducer,
    accessTokenType: accessTokenTypeReducer,
    mpvd: mvpdReducer,
    cdnTokenContentPath: cdnTokenContentPathReducer,
    requiresCDNToken: requiresCDNTokenReducer,
});


// WEBPACK FOOTER //
// ./src/player/cdnToken/reducer.js